import { environment } from '../../../environments/environment';

export const AUTH_CONFIG = {
  debugSessionLogging: environment.auth.debugSessionLogging,
  storageKey: environment.auth.storageKey,
  tokenStorageKey: environment.auth.tokenStorageKey,
  entra: environment.auth.entra,
} as const;
